import { UserData } from "commons/types";
import { createContext } from "react";

export const AuthContext = createContext<UserData | null>(null);